<template>
  <div class="settings-call-screen-pop">
    <div class="call-screen-pop ma-2">
      <call-screen-pop />
    </div>
  </div>
</template>

<script>
import CallScreenPop from '@/components/settings/screen_pop'

export default {
  name: 'settings-call-screen-pop',
  components: {
    CallScreenPop
  }
}
</script>

<style></style>
